import { RangeFilterValue } from '../../Filter/RangeFilterValue';

export class Scaling {
    private readonly minPosition: number;
    private readonly minValue: number;
    private readonly scale: number;

    constructor(bounds: RangeFilterValue, maxPosition: number) {
        // Position will be between 0 and given `maxPosition`
        const minPosition = 0;

        // The result should be between the bound ends
        const minValue = Math.log(bounds.min);
        const maxValue = Math.log(bounds.max);

        // Calculate adjustment factor
        const scale = (maxValue - minValue) / (maxPosition - minPosition);

        this.minPosition = minPosition;
        this.minValue = minValue;
        this.scale = scale;
    }

    public mapPositionToValue(position: number) {
        return Math.exp(this.minValue + this.scale * (position - this.minPosition));
    }

    public mapValueToPosition(value: number): number {
        return (Math.log(value) - this.minValue) / this.scale + this.minPosition;
    }
}
